export const decorateEditorialHtml = (text?: string) => {
  if (!text) {
    return { __html: "" };
  }

  const htmlWithStyle = text
    .replace(/<h[1-2]/gi, '$& class="uitk-heading-4"')
    .replace(/<h[3-4]/gi, '$& class="uitk-heading-6"')
    .replace(/<h[5-9]/gi, '$& class="uitk-heading-5"')
    .replace(/<br>/gi, "")
    .replace(/<ul/gi, '$& class="uitk-type-list-300 all-y-margin-two"')
    .replace(/<ol/gi, '$& class="uitk-type-list-300 all-y-margin-two"')
    .replace(/<\/br>/gi, "");

  return { __html: htmlWithStyle };
};
